import getApiClient from 'src/utils/getApiClient'
import getCSRFToken from 'www/utils/get/getCSRFToken'
import type {
  ApiProfileRegisterPostParams,
} from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/api/apiProfileRegister.types'

export default {
  post(data: ApiProfileRegisterPostParams) {
    const axiosClient = getApiClient()

    return axiosClient.post(window.location.href, data, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
